export default "__VITE_ASSET__A9fzJCsv__"